<template>
<div class="wxUser OauthBox">
   <p class="animated flash  infinite">获取用户授权信息，请稍侯...</p>
</div>
</template>

<script>
import globalVar from '@/api/global_variable'
import axios from 'axios'
export default {
  name: 'Oauth',
  components: {
    
  },
  data () {
    return {
    }
  },
  filters: {
      
  },
  created(){
    let iswx=this.isWeixin();
    if(iswx){
      this.loginWx();
    }else{
      this.loginWb();
      console.log("调用微博接口");
    }
  },
  mounted () {
  },
  methods:{
         isWeixin(){
            var ua = window.navigator.userAgent.toLowerCase();
           // document.write(ua);
            /*&& !(ua.match(/weibo/i) == 'weibo') && !(ua.match(/webdebugger/i) == 'webdebugger')*/
            if ((ua.match(/MicroMessenger/i) == 'micromessenger')  ) {//非微信环境，重定向到二维码页面
               return true;
            }   
             return false;          
         },
         loginWb(){
          return;
         var that=this;
              $.ajax({
                    url:"http://interface.gd.sina.com.cn/gdif/weibo/uid.html",
                    type:"get",
                    async:false,
                    dataType:"jsonp",
                    success:function(res){
                        console.log(res)
                        if (res.error=='10000') {
                             console.log("成功获取用户用户");
                             localStorage.setItem("udata", JSON.stringify(res.data));
                             that.$router.push({ path: '/vrbox'});
                        }else{
                             console.log("请登录微博！");
                             window.location.href = "https://passport.weibo.cn/signin/login";
                        }
                    }
               });           
         },
         loginWx(){
              var appid = "wxccd29c5d7de65996";
                var r_uri_all = window.location.href.split("?")[0]+'#'+window.location.href.split("#")[1];
                var r_uri = window.location.href;
                var code = this.GetUrlParame('code')     // 截取code
                var that=this;
                   console.log(code)
                if (!code) { //如果没有获取到code参数
                    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + encodeURIComponent(r_uri) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
                }else{
                              $.ajax({
                                              url: "http://www.vweb365.com/php/wx/getuserinfo_vweb365.php",
                                              data: {
                                                  code: code
                                              },
                                              dataType: 'json',
                                              success: function(data) {
                                                console.log(data);
                                                  that.$router.push({ path: '/Vrbox'});
                                                return;
                                                  if (data.errcode == "40003") {
                                                      alert("获取用户信息失败，请重新进入此链接！");
                                                  } else if (data.errcode == "41001") {
                                                      console.log("或因code过期，使得缺少access_token参数");
                                                      window.location.href = r_uri_all;
                                                  } else {
                                                      console.log("成功获取用户用户");
                                                      console.log(data);
                                                      localStorage.setItem("udata", JSON.stringify(data));
                                                      that.$router.push({ path: '/Vrbox'});

                                                  }
                                              },
                                              error: function(error) {
                                                  console.log(error);
                                              }
                            });     
                }
         },
        // 截取code
        GetUrlParame (parameName) {
           console.log(window.location.search)
          /// 获取地址栏指定参数的值
          /// <param name="parameName">参数名</param>
          // 获取url中跟在问号后面的部分
          var parames = window.location.search
          // 检测参数是否存在
          if (parames.indexOf(parameName) > -1) {
            var parameValue = ''
            parameValue = parames.substring(parames.indexOf(parameName), parames.length)
            // 检测后面是否还有参数
            if (parameValue.indexOf('&') > -1) {
              // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
              parameValue = parameValue.substring(0, parameValue.indexOf('&'))
              // 去掉参数名, 得到最终纯值字符串
              parameValue = parameValue.replace(parameName + '=', '')
              return parameValue
            }
            return ''
          }
        }
  }
}
</script>

<style>
    .OauthBox{ display: flex; justify-content: center; align-items: center; font-size: 0.28rem; width: 100%;
    height: 100vh; background: url(../assets/images/page1_bj.jpg);  background-size: cover; top: 0;font-size: .36rem;
    color: #fff;}

</style>



// WEBPACK FOOTER //
// src/pages/Oauth.vue